import { achievements } from '../../data/achievements';
import { ui } from '../../data/ui';
import { AchievementCard } from '../ui/AchievementCard';
import { ScrollReveal } from '../ui/ScrollReveal';
import './AchievementsBlock.css';

export function AchievementsBlock() {
  return (
    <div className="achievements-block">
      <ScrollReveal>
        <h3 className="cert-subsection-title">{ui.certifications.achievementsTitle}</h3>
        <p className="cert-subsection-subtitle">{ui.certifications.achievementsSub}</p>
      </ScrollReveal>
      <div className="achievements-grid">
        {achievements.map((achievement, i) => (
          <AchievementCard key={achievement.id} achievement={achievement} index={i} />
        ))}
      </div>
    </div>
  );
}
